import React, { useEffect } from 'react'
import { useSelector, useDispatch } from 'react-redux'
import { useNavigate, useParams } from 'react-router-dom'
import { LinkContainer } from 'react-router-bootstrap'
import { Container, Table, Button, Alert, Row, Col } from 'react-bootstrap'
import { getNames, deleteName } from '../actions/nameActions'
import Loader from '../components/Loader'
import Message from '../components/Message'
import PaginateName from '../components/PaginateName'

// Import icons
import { FontAwesomeIcon } from '@fortawesome/react-fontawesome'
import { faTrash } from '@fortawesome/free-solid-svg-icons'

const ListManufacturers = ({ match }) => {
  const dispatch = useDispatch()
  const navigate = useNavigate()

  const { pageNumbername } = useParams() || 1
  const { keyword } = useParams()

  const nameList = useSelector((state) => state.nameList)
  const { loading, error, manufacturer, count, pagesname, pagename } = nameList

  const nameDelete = useSelector((state) => state.nameDelete)
  const { success: successDelete } = nameDelete

  const userLogin = useSelector((state) => state.userLogin)
  const { userInfo } = userLogin

  const delName = (id) => {
    if (window.confirm('Are you sure?')) {
      dispatch(deleteName(id))
      dispatch({ type: 'NAME_DELETE_RESET' })
    }
  }

  useEffect(() => {
    if (userInfo) {
      dispatch(getNames(pageNumbername, keyword))
    } else {
      dispatch({ type: 'NAME_LIST_RESET' })
      navigate('/login')
    }
  }, [dispatch, navigate, keyword, pageNumbername, userInfo, successDelete])

  return (
    <Container>
      <Row>
        <Col>
          {' '}
          <PaginateName pagesname={pagesname} pagename={pagename} />
        </Col>
        {userInfo && userInfo.isAdmin && (
          <>
            <Col className='text-right'>
              <LinkContainer to='/settings'>
                <Button variant='primary' size='sm' className='my-2'>
                  Add a manufacturer
                </Button>
              </LinkContainer>
            </Col>
          </>
        )}
      </Row>

      {alert.show && <Alert variant={alert.variant}>{alert.message}</Alert>}
      {count === 0 && <Message variant='info'>None Found</Message>}
      {loading ? (
        <Loader />
      ) : error ? (
        <Message variant='danger'>{error}</Message>
      ) : (
        <Table striped bordered hover responsive className='table-sm'>
          <thead className='my-2'>
            <tr>
              <th>
                <h3>Manufacturer</h3>
              </th>
            </tr>
          </thead>
          <tbody>
            {manufacturer.map((name) => (
              <tr key={name._id}>
                <td>{name.manufacturer}</td>
                {userInfo && userInfo.isAdmin && (
                  <>
                    <td>
                      <Button
                        variant='danger'
                        size='sm'
                        onClick={() => delName(name._id)}
                      >
                        <FontAwesomeIcon icon={faTrash} />
                      </Button>
                    </td>
                  </>
                )}
              </tr>
            ))}
          </tbody>
        </Table>
      )}
    </Container>
  )
}

export default ListManufacturers
